import * as auth from "../auth.js";

const baseUrl = window.appSettings.api.uri;

const Tools = {
  getRootAPI: () => {
    if (process.env.NODE_ENV === "development") {
      return baseUrl;
    }
    // For production, you can add the production API root later
    return baseUrl;
  },
  formatNumber: (number) => {
    return number.toLocaleString();
  },
  sendRequest: async (resource, params, method = "GET", signal = null) => {
    console.log("Got request", resource, params, method);
    
    let fullUrl;
    let options = {
      method: method.toUpperCase(),
      headers: {
        'Content-Type': 'application/json',
        ...(window.appSettings.isOidc ? {} : {
          Authorization: auth.getAccessToken(),
        })
      },
      signal: signal
    };

    if (method.toUpperCase() === "GET") {
      // Handle GET requests with query parameters
      let queryString = "";
      if (typeof params === "object" && params !== null) {
        // If params is an object (dictionary), add action parameter and convert to query string
        const paramsWithAction = { ...params, action: resource };
        const queryParts = [];

        for (const key of Object.keys(paramsWithAction)) {
          const value = paramsWithAction[key];

          if (Array.isArray(value)) {
            // If the value is an array, add multiple parameters with the same name
            value.forEach((item) => {
              queryParts.push(
                `${encodeURIComponent(key)}=${encodeURIComponent(item)}`
              );
            });
          } else {
            queryParts.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            );
          }
        }

        queryString = queryParts.join("&");
      } else if (typeof params === "string") {
        // If params is already a string, append the action parameter
        queryString = params
          ? `${params}&action=${encodeURIComponent(resource)}`
          : `action=${encodeURIComponent(resource)}`;
      } else {
        // If params is neither an object nor a string, create a new query string with just the action
        queryString = `action=${encodeURIComponent(resource)}`;
      }

      fullUrl = Tools.getRootAPI() + "/api" + (queryString ? `?${queryString}` : "");
    } else {
      // Handle POST requests with body data
      fullUrl = Tools.getRootAPI() + "/api?action=" + encodeURIComponent(resource);
      options.body = JSON.stringify(params);
    }

    console.log("Sending to:", fullUrl);

    let response;
    console.debug("Request opts:", JSON.stringify(options, null, 4));
    try {
      response = await fetch(fullUrl, options);
    } catch (e) {
      // If this is an abort error, don't retry, just propagate it
      if (e.name === 'AbortError') {
        throw e;
      }
      
      if (window.appSettings.isOidc) {
        alert("Request error:", e);
      } else {
        // Invalid auth token
        try {
          // Retry
          const newToken = await auth.refreshToken();
          options.headers.Authorization = newToken;
          response = await fetch(fullUrl, options);
        } catch (e) {
          // If retry aborted, propagate the abort error
          if (e.name === 'AbortError') {
            throw e;
          }
          // refresh failed
          auth.logOut();
          throw e;
        }
      }
    }

    console.debug("Response:", response);
    let data = await response.json();
    if (!response.ok) {
      alert("There was an error. Message:" + JSON.stringify(data));
    }

    // Process the data if the resource is 'get-data'
    if (resource === "get-data") {
      const fieldsToConvert = [
        "agent_percent",
        "agent_performance_score",
        "agent_sentiment",
        "customer_experience_score",
        "customer_final_satisfaction",
        "customer_sentiment",
      ];

      if (Array.isArray(data.data)) {
        data.data = data.data.map((item) => {
          fieldsToConvert.forEach((field) => {
            if (
              item[field] !== null &&
              item[field] !== undefined &&
              item[field] !== ""
            ) {
              item[field] = parseFloat(item[field]);
            }
          });
          return item;
        });
      }
    }

    return data;
  },
};

export default Tools;